import styled from "styled-components"

export const NowDisplayinggWrapper = styled.div`
   padding-bottom: 3rem;
`
